
import {
    HiverAnalyticsAxios,
    CreateApiHandler,
    showMessage
  } from "h-commons";

  import {
      GET_REMOVE_CONVERSATION_AUTOMATION_DATA,
      UPDATE_REMOVE_CONVERSATION_AUTOMATION,
      CREATE_REMOVE_CONVERSATION_AUTOMATION,
      TOGGLE_REMOVE_CONVERSATION_AUTOMATION,
      TOGGLE_REMOVE_CONVERSATION_SETTINGS_VIEW
    } from '../actionTypes'
    
  export const toggleRemovedConversationAutomation = CreateApiHandler( async ({smId, enabled}) => {
    const response = await  HiverAnalyticsAxios({
     url: `/${smId}/removed_conversations/schedule`,
     type: "PATCH",
     params: {
        enabled
     }
   });


   showMessage({ 
     message: `Removed conversations log service has been ${enabled ? 'enabled' : 'disabled' }`, 
     autoClose: true,
     type : 'info-dark'
     })

   return {
     ...(response.parsedBody || {}),
     enabled,
     smId
   }
 }, TOGGLE_REMOVE_CONVERSATION_AUTOMATION)
 

export const getRemovedConversationAutomationData = CreateApiHandler( async ({smId}) => {
  const response = await HiverAnalyticsAxios({
    url: `/${smId}/removed_conversations/schedule`,
    type: "GET",
  });

  return {
    ...(response.parsedBody || {}),
    smId,
  }
}, GET_REMOVE_CONVERSATION_AUTOMATION_DATA)

export const createRemoveConversationAutomation =  CreateApiHandler(async ({
     smId, 
     scheduleType,
     timeOfday, 
     emails, 
     timeZone,
     extraData
    }) => {

      const payload = {
        "schedule": {
            ...extraData,
            "time_of_day": timeOfday,
            "schedule_type": scheduleType,
          },
          emails,
          "timezone": timeZone
      }

      const response = await HiverAnalyticsAxios({
          url: `/${smId}/removed_conversations/schedule`,
          type: "POST",
          params: payload
        })

        showMessage({ 
          message: 'Removed conversations log service has been enabled', 
          autoClose: true,
          type : 'info-dark'
          })
         
        return {
          ...payload,
          ...(response.parsedBody || {}),
          smId
        }

}, CREATE_REMOVE_CONVERSATION_AUTOMATION)


export const updateRemoveConversationAutomation =  CreateApiHandler(async ({
    smId, 
    scheduleType,
    timeOfday, 
    emails, 
    timeZone,
    extraData
   }) => {

    const payload = {
      "schedule": {
          ...extraData,
          "time_of_day": timeOfday,
          "schedule_type": scheduleType,
        },
        emails,
        "timezone": timeZone
    }

     const response = await HiverAnalyticsAxios({
         url: `/${smId}/removed_conversations/schedule`,
         type: "PUT",
         params: payload
       })
       return {
        ...payload,
        ...(response.parsedBody || {}),
        smId
      }  
}, UPDATE_REMOVE_CONVERSATION_AUTOMATION)

export const toggleRemoveConversationView = (status,smId) => ({
  type: TOGGLE_REMOVE_CONVERSATION_SETTINGS_VIEW,
  payload: {status,smId}
})